import { render, staticRenderFns } from "./Buscador.vue?vue&type=template&id=7bd7c450&scoped=true"
import script from "./Buscador.vue?vue&type=script&lang=js"
export * from "./Buscador.vue?vue&type=script&lang=js"
import style0 from "./Buscador.vue?vue&type=style&index=0&id=7bd7c450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd7c450",
  null
  
)

export default component.exports